import React, { useEffect, useState } from "react";
import SummaryApi from "../common";
import { useNavigate } from "react-router-dom";

const AllTeamLeads = () => {
  const [teamLeads, setTeamLeads] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const headers = {
    'Authorization': 'Bearer sandeep_university_916',
    'Content-Type': 'application/json',
  };

  useEffect(() => {
    const fetchTeamLeads = async () => {
      try {
        const response = await fetch(SummaryApi.getAllTL.url, {
          method: SummaryApi.getAllTL.method,
          headers,
        });

        if (!response.ok) throw new Error("Network response was not ok");

        const data = await response.json();

        if (data.status && Array.isArray(data.data)) {
          setTeamLeads(data.data);
        } else {
          setTeamLeads([]);
        }
      } catch (err) {
        setError("Failed to load team leads");
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchTeamLeads();
  }, []);

  // 🧭 When a row is clicked
  const handleRowClick = (lead) => {
    // Encode and store the selected team lead ID
    const encodedId = btoa(lead.employee_id); // base64 encode
    sessionStorage.setItem("H7Z4L9VD2XK5JW8QRYT6", encodedId);

    // Navigate to the employees page
    navigate("/my-employees");
  };

  if (loading)
    return (
      <div className="flex justify-center items-center h-64 text-lg text-gray-600">
        Loading team leads...
      </div>
    );

  if (error)
    return (
      <div className="flex justify-center items-center h-64 text-red-500 font-semibold">
        {error}
      </div>
    );

  return (
    <div className="max-w-8xl mx-auto p-6">
      <h2 className="text-2xl font-bold mb-6 text-gray-800 text-center">
        All Team Leads
      </h2>

      <div className="overflow-x-auto bg-white shadow-md rounded-lg">
        <table className="min-w-full border border-gray-200">
          <thead className="bg-gradient-to-r from-indigo-500 to-purple-600 text-white">
            <tr>
              <th className="py-3 px-4 text-left font-semibold">Full Name</th>
              <th className="py-3 px-4 text-left font-semibold">Mobile Number</th>
              <th className="py-3 px-4 text-left font-semibold">Assigned Employees</th>
            </tr>
          </thead>
          <tbody>
            {teamLeads.length > 0 ? (
              teamLeads.map((lead, index) => (
                <tr
                  key={lead.employee_id || index}
                  onClick={() => handleRowClick(lead)} // 🧭 Navigate on click
                  className={`border-b hover:bg-indigo-50 cursor-pointer transition ${
                    index % 2 === 0 ? "bg-gray-50" : "bg-white"
                  }`}
                >
                  <td className="py-3 px-4 text-gray-800">{lead.full_name}</td>
                  <td className="py-3 px-4 text-gray-700">{lead.mobile_number}</td>
                  <td className="py-3 px-4 text-center font-medium text-indigo-600">
                    {lead.assigned_employee_count}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="3" className="text-center py-4 text-gray-500 italic">
                  No team leads found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AllTeamLeads;
